/**
 * Inline form-field error message.
 *
 * @param {string} value The error message to display
 * @param {string} [className] Additional CSS classes
 */
const ErrorMessage = ({ value, className }) => {
  if (!value) return null;

  return (
    <span
      role="alert"
      className={`mt-1.5 inline-flex items-center gap-1.5 text-[13px] font-semibold leading-snug text-rose-600 dark:text-rose-400 ${
        className || ""
      }`}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 16 16"
        fill="none"
        className="h-3.5 w-3.5 shrink-0"
      >
        <circle
          cx="8"
          cy="8"
          r="7"
          fill="currentColor"
          fillOpacity="0.12"
        />
        <path
          d="M8 4.5v4M8 11.25v.01"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
      <span className="tracking-tight">{value}</span>
    </span>
  );
};

export default ErrorMessage;
